import { useContext } from 'react';
import { ValidClaimContext } from '../contexts/validClaimContext';

export const useValidClaim = () => useContext(ValidClaimContext);
